// extracted by mini-css-extract-plugin
export default {"anchor":"pb","codeSpan":"qb","codeBlock":"rb","title1":"sb","title2":"tb","title3":"ub"};